var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("h5", [_vm._v("Регулярные и разовые планы перемещений на склады")]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("DateSelectProps", {
                attrs: {
                  disabled: true,
                  disabledDatesBefore: _vm.disabledDates,
                  selectedDate: null,
                  onSelect: (date) => (this.newSendTime = date),
                },
              }),
              _vm._v(" "),
              _c("div", [
                _vm._v("\n            " + _vm._s(_vm.preSets) + "\n          "),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-8 flex" },
            [
              _c("multiselect", {
                attrs: {
                  name: "user_role",
                  noShotCuts: true,
                  options: Object.values(_vm.$AllStores).filter(
                    (s) => s.is_active && ![1, 2, 3, 4].includes(s.id)
                  ),
                  placeholder: "Выберите города",
                  "track-by": "title",
                  label: "title",
                  showLabels: false,
                  searchable: false,
                  multiple: true,
                },
                model: {
                  value: _vm.newReceivers,
                  callback: function ($$v) {
                    _vm.newReceivers = $$v
                  },
                  expression: "newReceivers",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: { click: _vm.addCustomDelivery },
                },
                [_vm._v("Добавить")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.customDelivery && _vm.customDelivery.length
          ? _c("div", [
              _c("hr"),
              _vm._v(" "),
              _c("table", { staticClass: "table table-sm" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.customDelivery, function (delivery, index) {
                    return _c("tr", [
                      _c("td", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$AllStores[delivery.receive_store_id]
                                .short_title
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(delivery.send_date))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("DateTimeSelect", {
                            attrs: {
                              onSelect: (date) =>
                                (_vm.customDelivery[index].delivery_date =
                                  date),
                              selectedDate: delivery.delivery_date,
                              useDisabledDates: new Date(),
                              disabled: true,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("button", { staticClass: "btn btn-danger" }, [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-trash",
                            on: {
                              click: function ($event) {
                                return _vm.deleteRecord(
                                  delivery.id,
                                  index,
                                  "custom"
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    !_vm.loading
      ? _c("div", [
          _vm.records && _vm.records.length > 0
            ? _c(
                "div",
                _vm._l(_vm.$AllStores, function (store) {
                  return store.is_active && ![1, 2, 3, 4].includes(store.id)
                    ? _c("div", { staticClass: "card" }, [
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          [
                            _c(
                              "div",
                              { staticClass: "flex justify-content-between" },
                              [
                                _c("div", [
                                  _c("strong", [
                                    _vm._v(_vm._s(store.short_title)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                false && _vm.storeSettings[store.id]
                                  ? [
                                      _c("div", [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Количество дней в пути"),
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.storeSettings[store.id]
                                                  .days,
                                              expression:
                                                "storeSettings[store.id].days",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "number" },
                                          domProps: {
                                            value:
                                              _vm.storeSettings[store.id].days,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.storeSettings[store.id],
                                                "days",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("Время прибытия"),
                                          ]),
                                          _vm._v(" "),
                                          _c("TimeSelect", {
                                            attrs: {
                                              selectedDate:
                                                _vm.storeSettings[store.id]
                                                  .time,
                                              onSelect: (date) =>
                                                (_vm.storeSettings[
                                                  store.id
                                                ].time = date),
                                              disabled: true,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", {}, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-outline-success",
                                      staticStyle: { bottom: "0" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addNewRecord(store.id)
                                        },
                                      },
                                    },
                                    [_vm._v("Добавить отправление")]
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.sortedRecords[store.id]
                              ? [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-hover table-sm mt-1",
                                    },
                                    [
                                      _vm._m(1, true),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          [
                                            ...(_vm.sortedRecords[store.id] ||
                                              []),
                                          ],
                                          function (record, index) {
                                            return _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  class: {
                                                    not_active:
                                                      !record.regular_delivery,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: record.day_num,
                                                          expression:
                                                            "record.day_num",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.$set(
                                                            record,
                                                            "day_num",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "1" },
                                                        },
                                                        [_vm._v("Понедельник")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "2" },
                                                        },
                                                        [_vm._v("Вторник")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "3" },
                                                        },
                                                        [_vm._v("Среда")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "4" },
                                                        },
                                                        [_vm._v("Четверг")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "5" },
                                                        },
                                                        [_vm._v("Пятница")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "6" },
                                                        },
                                                        [_vm._v("Суббота")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "7" },
                                                        },
                                                        [_vm._v("Воскресенье")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  class: {
                                                    not_active:
                                                      !record.regular_delivery,
                                                  },
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          record.day_duration,
                                                        expression:
                                                          "record.day_duration",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: { type: "number" },
                                                    domProps: {
                                                      value:
                                                        record.day_duration,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          record,
                                                          "day_duration",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  class: {
                                                    not_active:
                                                      !record.regular_delivery,
                                                  },
                                                },
                                                [
                                                  _c("TimeSelect", {
                                                    attrs: {
                                                      selectedDate:
                                                        record.delivery_time,
                                                      onSelect: (date) =>
                                                        (record.delivery_time =
                                                          date),
                                                      disabled: true,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: record.is_active,
                                                      expression:
                                                        "record.is_active",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "checkbox",
                                                    id: `ch_${record.id}`,
                                                  },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      record.is_active
                                                    )
                                                      ? _vm._i(
                                                          record.is_active,
                                                          null
                                                        ) > -1
                                                      : record.is_active,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a =
                                                          record.is_active,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              record,
                                                              "is_active",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              record,
                                                              "is_active",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          record,
                                                          "is_active",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-danger",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-trash",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.deleteRecord(
                                                            record.id,
                                                            index,
                                                            "regular",
                                                            store.id
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ])
                    : _vm._e()
                }),
                0
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "text-right" },
      [
        _c("LoadingButton", {
          attrs: {
            title: "Сохранить",
            className: "btn btn-success",
            onClick: () => _vm.saveRecords(),
            loading: _vm.saveLoading,
            color: _vm.$constants.SUCCESS_COLOR,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Дата/Время отправки")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата/Время прибытия")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("День недели отправки")]),
        _vm._v(" "),
        _c("th", [_vm._v("Количество дней в пути")]),
        _vm._v(" "),
        _c("th", [_vm._v("Время прибытия")]),
        _vm._v(" "),
        _c("th", [_vm._v("Активно")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }